declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleMedicineDataRequest, SaveClinicalOrderRxHeaderInfoRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ngbeditprescriptionmedicine',
  templateUrl: './editprescriptionmedicine.modal.html',
  styleUrls: ['./editprescriptionmedicine.modal.scss']
})

export class NgbEditPrescriptionMedicineModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() CurrentEditClinicalOrderRxHeaderInfoRequest: SaveClinicalOrderRxHeaderInfoRequest;
  CurrentStopMedicine: SaveClinicalOrderRxHeaderInfoRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() MedicineName: string;
  @Input() ActivityCode: number;
  @Input() CycleCode: number;
  @Input() ActorCode1: number;
  @Input() ClinicalOrderRxItemCode: number;
  @Input() ClinicalOrderEntry: number;
  @Input() MedicineCode: number;
  @Input() ClinicalOrderItem: number;
  @Input() ScanDate: Date;
  @Input() TcModelName: string;
  @Input() Typeofscreen: string;
  public Purpose: string;
  public Dose: string;
  public DurationType: string;
  public Route: string;
  public Frequency: string;
  public Instructions: string;
  StartDate: NgbDateStruct;
  ToDate: NgbDateStruct;
  EndDate: NgbDateStruct;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  TodayDate = new Date();
  CurrentSaveIvfCycleMedicineDataRequest: SaveIvfCycleMedicineDataRequest;
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, private parserFormatter: NgbDateParserFormatter,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService, private spinner: NgxSpinnerService) { }
  ActorCode: number;
  ngOnInit() {
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.ShowService = false;
    //alert(this.Typeofscreen);
    this.StartDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.ToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.CurrentSaveIvfCycleMedicineDataRequest = new SaveIvfCycleMedicineDataRequest();
    this.CurrentSaveIvfCycleMedicineDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentStopMedicine = new SaveClinicalOrderRxHeaderInfoRequest();
    this.CurrentStopMedicine.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.CurrentEditClinicalOrderRxHeaderInfoRequest.StartDate != null) {
      var SValidFrom = new Date(this.CurrentEditClinicalOrderRxHeaderInfoRequest.StartDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.StartDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    if (this.CurrentEditClinicalOrderRxHeaderInfoRequest.EndDate != null) {
      var SValidFrom = new Date(this.CurrentEditClinicalOrderRxHeaderInfoRequest.EndDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.ToDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
  }

  CurrentMedicineDetails: Array<MedicineDetails>;

  ReturnData() {
    // alert(this.DurationType);
    if (this.CurrentMedicineDetails == null) {
      this.CurrentMedicineDetails = new Array<MedicineDetails>();
    }
    if (this.CurrentMedicineDetails != null) {
      var row = new MedicineDetails();
      row.Dose = this.Dose;
      row.DurationType = this.DurationType;
      row.Frequency = this.Frequency;
      row.Instructions = this.Instructions;
      row.MedicineName = this.MedicineName;
      row.MedicineCode = 0;
      row.Purpose = this.Purpose;
      row.Route = this.Route;
      row.StartDate = new Date(this.parserFormatter.format(this.StartDate));
      row.ToDate = new Date(this.parserFormatter.format(this.ToDate));
      this.CurrentMedicineDetails.push(row);
      //alert(this.CurrentMedicineDetails[0].MedicineName);
    }
    //this.activeModal.close(this.CurrentMedicineDetails);
    this.passEntry.emit({ make: this.CurrentMedicineDetails });
    this.activeModal.close();
  }




  onSubmit() {

    this.StartRefreshing();
    this.spinner.show();
    if (this.CurrentStopMedicine.IsStopped) {
      this.CurrentStopMedicine.ConditionalOperator = 30;

      this.CurrentStopMedicine.ClinicalOrderRxItemCode = this.ClinicalOrderRxItemCode;
      this.CurrentStopMedicine.ClinicalOrderEntry = this.ClinicalOrderEntry;
      this.CurrentStopMedicine.StopDate = new Date();
      this.actorservice.SaveClinicalOrderRxHeaderInfo(this.CurrentStopMedicine)
        .subscribe((result) => {
          this.ApiResData = result;
          if (result.Result[0].ClinicalOrderEntry > 0) {
            //if (!this.ApiResData.hasError) {

            //   if (this.ApiResData.Result > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.activeModal.close();
            this.spinner.hide();

            // this.Listview = true;
            //this.EditEmbryo = false;
            //this.LoadStoreData();
            //this.AddEmbryo = false;
            //this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();
            this.spinner.hide();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation :- " + "...!");

            //this.spinner.hide();
            this.stopRefreshing();
            this.spinner.hide();
          }

        },


          (error) => {

            if (error == "401 - Unauthorized") {
              alertFunctions.AlertParamEr(error);
              this.spinner.hide();
              this.stopRefreshing();



            }
            else {
              alertFunctions.AlertParamEr(error);
              this.spinner.hide();
              this.stopRefreshing();
            }
          }
        );
    }
    else {
      this.CurrentEditClinicalOrderRxHeaderInfoRequest.ConditionalOperator = 20;


      //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

      this.CurrentEditClinicalOrderRxHeaderInfoRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
      this.CurrentEditClinicalOrderRxHeaderInfoRequest.EndDate = new Date(this.parserFormatter.format(this.ToDate));

      this.actorservice.SaveClinicalOrderRxHeaderInfo(this.CurrentEditClinicalOrderRxHeaderInfoRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          if (result.Result[0].ClinicalOrderEntry > 0) {
            //if (!this.ApiResData.hasError) {

            //   if (this.ApiResData.Result > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.activeModal.close();
            this.spinner.hide();
            // this.Listview = true;
            //this.EditEmbryo = false;
            //this.LoadStoreData();
            //this.AddEmbryo = false;
            //this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();
            this.spinner.hide();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation :- " + "...!");

            //this.spinner.hide();
            this.stopRefreshing();
            this.spinner.hide();
          }

        },


          (error) => {

            if (error == "401 - Unauthorized") {
              alertFunctions.AlertParamEr(error);
              this.activeModal.close();
              this.stopRefreshing();
              this.spinner.hide();



            }
            else {
              alertFunctions.AlertParamEr(error);
              this.activeModal.close();
              this.stopRefreshing();
              this.spinner.hide();
            }
          }
        );
    }
  }
  onStop(e) {

    var statusVal = e.target.checked;
    this.CurrentStopMedicine.ConditionalOperator = 30;
    this.CurrentStopMedicine.IsStopped = statusVal;
    this.CurrentStopMedicine.ClinicalOrderRxItemCode = this.ClinicalOrderRxItemCode;
    this.CurrentStopMedicine.ClinicalOrderEntry = this.ClinicalOrderEntry;
    this.CurrentStopMedicine.StopDate = new Date();
    this.actorservice.SaveClinicalOrderRxHeaderInfo(this.CurrentStopMedicine)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');


            // this.LoadDoctorAppointmentsByDoctor();
            //this.LoadAppointmentDetailsByAppointmentCode(this.SelectedAppointmentDetails.AppointmentCode);
            //this.GetAppointmentDetailsByAppointmentCodeContoller();


            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  onAssignedToActorCode(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = event;
      this.CurrentSaveIvfCycleMedicineDataRequest.MedicineName = event;
      //alert( this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode)
      // console.log('event--_>' + event);
      //   }
    }

  }



}
export class MedicineDetails {

  public MedicineName: string;
  public MedicineCode: number;
  public Purpose: string;
  public Dose: string;
  public DurationType: string;
  public Route: string;
  public Frequency: string;
  public Instructions: string;
  public StartDate: Date;
  public ToDate: Date;

}
